import React, { useState, useEffect } from "react";
import {
  Modal,
  Button,
  Form,
  Space,
  Steps,
  Result,
  Input,
  DatePicker,
} from "antd";
import TextArea from "antd/es/input/TextArea";
import { useStepsForm } from "sunflower-antd";

import { getMemberApi } from "../../../services/Member/MemberApis";

interface IModalProps {
  show: boolean;
  claimId: any;
  showModal: Function;
  handleAdd: Function;
}

const CloseClaimModal: React.FC<IModalProps> = ({
  show,
  claimId,
  showModal,
  handleAdd,
}) => {
  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");

  const handleModal = () => {
    showModal();
    gotoStep(0);
    form.resetFields();
  };

  const {
    form,
    current,
    gotoStep,
    stepsProps,
    formProps,
    submit,
    formLoading,
  } = useStepsForm({
    isBackValidate: false,
    async submit(values: any) {
      setLoading(true);

      const response = await handleAdd(
        {
          ...values,
          // Date: dayjs(values.Date, "YYYY-MM-DD"),
        },
        claimId
      );

      if (response.success) {
        setLoading(false);
        return true;
      }
      setErrorMsg(response.message);
      setLoading(false);
      return false;
    },
    total: 2,
  });

  const layout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 8 },
  };

  const tailLayout = {
    labelCol: { span: 0 },
    wrapperCol: { offset: 8, span: 8 },
  };

  const formList: any = [
    <>
      <Form.Item name="Notes" label="Notes">
        <TextArea size="large" id="Notes" placeholder="Notes" />
      </Form.Item>

      <Form.Item {...tailLayout}>
        <Space direction="vertical" style={{ width: "100%" }}>
          <Button
            loading={loading}
            style={{ marginBottom: 10 }}
            block
            size="large"
            onClick={() => {
              submit().then((result: any) => {
                if (result) {
                  gotoStep(current + 1);
                } else if (!result) {
                  gotoStep(current + 2);
                }
              });
            }}
          >
            Submit
          </Button>
        </Space>
      </Form.Item>
    </>,
  ];

  return (
    <Modal
      title="Close Claim"
      open={show}
      onOk={handleModal}
      onCancel={handleModal}
      width={600}
      footer={null}
    >
      {/* Steps Form */}
      <div>
        <div style={{ marginTop: 60 }}>
          <Form {...layout} {...formProps} style={{ maxWidth: 900 }}>
            {formList[current]}
          </Form>

          {current === 1 && (
            <Result status="success" title="Successfully submitted.">
              <Space direction="vertical" style={{ width: "100%" }}>
                <Button block size="large" onClick={handleModal}>
                  Okay
                </Button>
              </Space>
            </Result>
          )}

          {current === 2 && (
            <Result status="error" title={errorMsg}>
              <Space direction="vertical" style={{ width: "100%" }}>
                <Button block size="large" onClick={handleModal}>
                  Okay
                </Button>
              </Space>
            </Result>
          )}
        </div>
      </div>
    </Modal>
  );
};

export default CloseClaimModal;
